import React from "react";
import "./SDKViewer.scss"; // Keep or create this SCSS file for styling
import MarkdownRenderer from "../MarkdownRenderer/MarkdownRenderer";
import { PulseTextField } from "@pulselabs-ai/shared-fe-ui";

interface SDKViewerProps {
  instructions: string; // Expect formatted instructions string
  appKey: string | null | undefined; // Expect the app key
}

const SDKViewer: React.FC<SDKViewerProps> = ({ instructions, appKey }) => {
  // No fetching logic, no useEffect, no state needed here

  return (
    <div className="sdk-viewer">
      <div className="installation-block">
        {/* Render the instructions passed as a prop */}
        <MarkdownRenderer content={instructions} />
      </div>

      {/* Conditionally render the API key section if appKey is provided */}
      {appKey && (
        <div className="api-key-section">
          <h2 className="pl-heading-xs-extra-bold">API Key</h2>
          <PulseTextField
            value={appKey} // Display the appKey passed as a prop
            // readOnly={true}
            // isCopyIconVisible={true}
          />
        </div>
      )}
    </div>
  );
};

export default SDKViewer;
